<template>
  <div class="community-card-box">
    <div class="community-card__block">
      <div class="community-card__name">{{ community.name }}</div>
      <div class="community-card__selected">
        <label>
          <b-radio
            v-model="userId"
            color="red"
            type="radio"
            name="radio2"
            fill
            :value="community.id"
            @click="selectCommunity(community.id)"
          />
        </label>
      </div>
    </div>
    <div class="community-card__header">Юридический адрес:</div>
    <div class="community-card__value">{{ community.address }}</div>
    <div class="community-card__header">УНП:</div>
    <div class="community-card__value">{{ community.unp }}</div>
    <div class="community-card__header">Дополнительная информация:</div>
    <div class="community-card__value">{{ community.description }}</div>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'DesktopRightMenuOpenedCommunity',
  props: {
    community: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    userId: null
  }),
  computed: {
    ...mapState({
      selectedCommunityId: state => state.community.selectedCommunityId
    })
  },
  methods: {
    ...mapMutations({
      setCommunity: 'community/SELECT_COMMUNITY'
    }),
    selectCommunity(id) {
      this.setCommunity(id)
    }
  },
  mounted() {
    this.userId = this.selectedCommunityId
    this.value = this.selectedCommunityId
  }
}
</script>
